module.exports = __webpack_public_path__ + "img/British-Virgin-Islands.62eb3707.png";